import React from 'react';
import PropTypes from 'prop-types';

import Container from 'react-bootstrap/Container';
// import styled from 'styled-components';
import NavBarBanner from '../../atoms/NavBarBanner/NavBarBanner';
import ImageContainer from '../../../../components/molecules/ImageContainer';
import PageTitle from '../../atoms/PageTitle';

// const Wrapper = styled.div`
//     ${ImageContainer} {
//         width: 20%;
//         height: 20%;
//         maxWidth: 160px;
//         minWidth: 80px;
//         padding: 0 20px 0 0;
//     }
// `;

const StaffNavBarTemplate = (props) => {
  const {
    pageLogo,
    pageName,
  } = props;

  return (
    <NavBarBanner background="dark" id="navBarLogo">
      <Container>
        <ImageContainer
          image={{
            id: 'monarchLogo0',
            alt: 'Monarch Butterfly Logo',
            src: pageLogo,
            objectFit: 'cover',
          }}
          width="20%"
          height="20%"
          maxWidth="160px"
          minWidth="80px"
          padding="0 20px 0 0"
        />
        <PageTitle pageName={pageName} />
      </Container>
    </NavBarBanner>
  );
};

StaffNavBarTemplate.propTypes = {
  pageLogo: PropTypes.string.isRequired,
  pageName: PropTypes.string.isRequired,
};

export default StaffNavBarTemplate;
